import React from 'react';
import { version } from '../../config';

const Footer = () => (
  <footer className="hl-footer d-flex flex-column flex-sm-row justify-content-between text-center">
    <p className="mb-1 mb-sm-0">&copy;{new Date().getFullYear()} Grupo Homelan, C.A. J-508676335</p>
    <p className="mb-0">v {version}</p>
  </footer>
);

export default React.memo(Footer);
